'use client';

import type { DrawerRefValue } from '@unifyapps/carbon/components/Drawer';
import type React from 'react';
import { createContext, useContext } from 'react';

export type { DrawerRefValue };

const DrawerRefContext = createContext<React.RefObject<DrawerRefValue> | null>(null);

export function useDrawerRefContext(): React.RefObject<DrawerRefValue> | null {
  return useContext(DrawerRefContext);
}

/**
 * Hierarchy: DrawerRefProvider wraps InterfaceActionProvider (actions read the ref via useDrawerRefContext) and
 * DrawerProvider below receives the same ref so show/hide are assigned when the drawer mounts.
 */
export function DrawerRefProvider({
  children,
  drawerRef,
}: {
  children: React.ReactNode;
  drawerRef: React.RefObject<DrawerRefValue>;
}) {
  return <DrawerRefContext.Provider value={drawerRef}>{children}</DrawerRefContext.Provider>;
}
